import { render, staticRenderFns } from "./vMissionPage.vue?vue&type=template&id=5f85872c&scoped=true"
import script from "./vMissionPage.vue?vue&type=script&lang=js"
export * from "./vMissionPage.vue?vue&type=script&lang=js"
import style0 from "./vMissionPage.vue?vue&type=style&index=0&id=5f85872c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f85872c",
  null
  
)

export default component.exports